import './DonationConfirm.css';
import { useEffect } from 'react';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { XIcon } from '../components/SocialMediaIcon';

export default function DonationConfirm() {
    const location = useLocation()
    useEffect(()=>{
      ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Donation Confirm Page' });
    }, []);
    return <div className="donation-confirm-container" style={{display:'flex',justifyContent:'center', flexDirection: 'column',width: "50%",marginRight: "auto",marginLeft: "auto"}}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Donation-Confirmation</title>
      </Helmet>
      <h3>Your transaction was successful.</h3>
      <p>Welcome to the community!  Your support helps our global work toward developing a blue, healthy planet, planting super trees, educating communities on sustainability, developing habitats with rich fauna and animal life, and restoring whole ecosystems.</p>
      <p>Login to your account to keep track of the trees you are planting, the CO2 you are absorbing, and the oxygen your generosity is creating.</p>
      <p>Thank you for joining Blue Planet Ecosystem!</p>
      <p>Together, we are making a difference.</p>
      <p>Share this on social media</p>
      <div>
        <XIcon />
      </div>
    </div>
}